import { toRaw } from 'vue';
import { Message } from "../types/chat";

/**
 * Formats the current time as HH:MM:SS
 */
function getTimestamp(): string {
    return new Date().toLocaleTimeString('en-US', { hour12: false });
}

/**
 * Logs tool calls to the console with formatted output
 * @param toolName The name of the tool being called
 * @param args The arguments passed to the tool
 */
export function logToolCall(toolName: string, args: any): void {
    try {
        switch (toolName) {
            case '_meiliSearchProgress': {
                const searchParams = JSON.parse(args.function_arguments);
                console.group(`🔎 [${args.call_id}] Assistant is performing a search | ${getTimestamp()}`);
                console.table({
                    index: searchParams.index_uid,
                    q: searchParams.q,
                    filter: searchParams.filter,
                });
                console.groupEnd();
                break;
            }

            case '_meiliSearchSources': {
                const sources = args.sources || [];
                console.group(`📚 [${args.call_id}] Found ${sources.length} document${sources.length !== 1 ? 's' : ''} | ${getTimestamp()}`);
                if (sources.length > 0) {
                    console.table(sources, ['id', 'title', 'url']);
                }
                console.groupEnd();
                break;
            }

            case '_meiliAppendConversationMessage': {
                const { role, content, tool_calls, tool_call_id } = args;
                console.groupCollapsed(`💬 Assistant wants to append messages to the context | ${getTimestamp()}`);
                console.log('Role:', role);
                console.log(content);
                if (tool_call_id) console.log('Tool call ID:', tool_call_id);
                if (tool_calls) console.log('Tool calls:', tool_calls);
                console.groupEnd();
                break;
            }
        }
    } catch (error) {
        console.error('Error logging tool call:', error);
    }
}

/**
 * Logs the conversation API call to the console
 * @param messages The full messages array being sent to the API
 */
export function logAPICall(messages: Message[]): void {
    const payload = JSON.stringify(toRaw(messages));
    const payloadBytes = new TextEncoder().encode(payload).length;
    const assistantCount = messages.filter((msg) => msg.role === 'assistant' && !msg.internal).length;
    const userCount = messages.filter((msg) => msg.role === 'user').length;
    const internalCount = messages.filter((msg) => msg.internal).length;

    console.groupCollapsed(`🤖 Sending messages to the chat API | ${getTimestamp()}`);
    console.log(`${payload.length} characters | ${payloadBytes} bytes`);
    console.log(`Total: ${messages.length} | Assistant: ${assistantCount} | User: ${userCount} | Internal: ${internalCount}`);
    console.log(JSON.parse(payload));
    console.groupEnd();
}
